import React, {Component, Fragment} from 'react'
import ClaimModal from './ClaimModal'
import List from './List'

class Claims extends Component {
  render() {
    return (
      <Fragment>
        <ClaimModal {...this.props} />
        <List {...this.props} />
      </Fragment>
    )
  }
}

Claims.propTypes = {}
Claims.defaultProps = {}

export default Claims
